import { ScheduledMessageFilesState } from './scheduled-message-files-selectors';
import { FAILURE, STARTING, SUCCESS } from '../action/util/action-name-creators';
import {
  Action,
  updateResourceByParam,
  setStateDirtyByParam,
} from '../reducers/utils/state-manager';

const InitialState: ScheduledMessageFilesState = {
  scheduledMessageFilesById: {},
  scheduledMessageFilesStateByEmployeeGroupId: {},
};

const scheduledMessageFilesById = (scheduledMessageFilesResult: ScheduledMessageFile[]) =>
  scheduledMessageFilesResult.reduce((a, v) => ({ ...a, [v.scheduledMessageFileId]: v }), {});

export const scheduledMessageFilesReducer = (state = InitialState, action: Action) => {
  switch (action.type) {
    case STARTING('LOAD_SCHEDULED_MESSAGE_FILES_BY_EMPLOYEE_GROUP'): {
      const {
        payload: {
          args: { employeeGroupId },
        },
      } = action;
      return updateResourceByParam(
        state,
        'scheduledMessageFiles',
        'employeeGroupId',
        employeeGroupId,
        true,
      );
    }
    case SUCCESS('LOAD_SCHEDULED_MESSAGE_FILES_BY_EMPLOYEE_GROUP'): {
      const {
        payload: {
          args: { employeeGroupId },
          data,
        },
      } = action;
      return updateResourceByParam(
        state,
        'scheduledMessageFiles',
        'employeeGroupId',
        employeeGroupId,
        false,
        scheduledMessageFilesById(data),
      );
    }
    case FAILURE('LOAD_SCHEDULED_MESSAGE_FILES_BY_EMPLOYEE_GROUP'): {
      const {
        payload: {
          args: { employeeGroupId },
        },
      } = action;
      return updateResourceByParam(
        state,
        'scheduledMessageFiles',
        'employeeGroupId',
        employeeGroupId,
        false,
      );
    }
    case SUCCESS('CREATE_ANNOUNCEMENT'): {
      const { employeeGroupId } = action.payload.args;
      return setStateDirtyByParam(
        state,
        'scheduledMessageFiles',
        'employeeGroupId',
        employeeGroupId,
      );
    }
    default:
      return state;
  }
};
